
































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  data: () => ({
    email: [(v) => (v === '' || /^\w[\.-_\w]*@[\w-_]+([\.]\w+)*(\.\w{2,3})+$/.test(v)) || 'Email incorrecto'],
    openDialog: false,
    nuevoCondo: {
      creationDateTime: '',
      creationUsername: '',
      nombre: '',
      direccion: '',
      rfc: '',
      contacto: '',
    },
  }),
  methods: {
    modeloCondo() {
      return {
        creationDateTime: '',
        creationUsername: '',
        nombre: '',
        direccion: '',
        rfc: '',
        contacto: '',
      };
    },
    async AgregarUnidad() {
      try {
        this.loading = true;
        this.nuevoCondo.creationDateTime = this.$moment().format();
        this.nuevoCondo.creationUsername = this.$store.getters.getUsername;
        const admin = this.$store.getters.getAdmin;
        const condo = this.nuevoCondo;
        const result = await this.$store.dispatch('addCondo', {admin, condo} );
        console.debug('ResultADDCONDO: %o', result);
        this.$toast.success('Condominio agregado');
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.openDialog = false;
      this.nuevoCondo = this.modeloCondo();
      this.$emit('reload', {});
    },
  },
  computed: {
    validateEmail() {
      if (/^\w[\.-_\w]*@[\w-_]+([\.]\w+)*(\.\w{2,3})+$/.test(this.nuevoCondo.contacto)) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    openDialog() {
      if (!this.openDialog) {
        this.nuevoCondo = this.modeloCondo();
      }
    },
  },
});
